import React, { useState, useEffect } from "react";
import { AiOutlineThunderbolt } from "react-icons/ai";
import { FiPause, FiPlay } from "react-icons/fi";
import { GrUndo } from "react-icons/gr";
import { IoArrowBackOutline } from "react-icons/io5";
import { LuRedo2, LuStarOff, LuView, LuEraser } from "react-icons/lu";
import { TbDatabasePlus, TbDatabase } from "react-icons/tb";
import { TbExchange } from "react-icons/tb";
import {
  MdAreaChart,
  MdBarChart,
  MdDownload,
  MdLineAxis,
  MdPieChart,
  MdPivotTableChart,
  MdScatterPlot,
  MdStackedBarChart,
  MdTableChart,
} from "react-icons/md";
import { PiShootingStar } from "react-icons/pi";
import { TbArrowsSort, TbChartTreemap } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ActionCreators } from "redux-undo";
import { AiOutlineRadarChart } from "react-icons/ai";
import { TbChartHistogram } from "react-icons/tb";
import { TbNumber123 } from "react-icons/tb";
import { FaMapMarkerAlt } from "react-icons/fa";
import { Dropdown } from "flowbite-react";
import { IoMdArrowDropdown } from "react-icons/io";
import { useGetDatasourceQuery } from "../../../dataSource/sql/TablesourceApiSlice";
import {
  CreateSheet,
  getL1SheetProperty,
  getWorkbookProperty,
  resetSheet,
  updateL1Property,
} from "../../WorkbookSlice";
import AreYouSureModal from "./AreYouSureModal";
import {
  getAside2components,
  getDefaultReduxState,
} from "../../../../middleware/getVizDetails";
import { buildCustomization } from "../../../../middleware/buildInitialSheetState";
import useAuth from "../../../../hooks/useAuth";

export default function Header2({
  pause,
  animationOff,
  actionModal,
  sortModal,
  handlePlayPause,
  handleAnimatation,
  setActionModal,
  setSortModal,
  currentSheetIsDashboard,
  handleCallFunction,
  currentSheet,
  handleModal,
  VizType,
  sheetsArrayLength,
  isAside4Visible,
  setIsAside4Visible,
  Sheetid,
  setDataSourceModal,
  roles,
  setTutorialModal
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [hoveredIcon, setHoveredIcon] = useState(null); // To track only one hovered icon at a time
  const [iconToDisplay, setIconToDisplay] = useState(null); // Control delayed display
  const [changeDsModal, setChangeDSModal] = useState(null);
  const [dataSource, setDataSource] = useState(null);
  let connnectedDataSets = null;
  const dataSourcesArray = useSelector((state) =>
    getWorkbookProperty(state, "dataSources")
  );
  const dataSourceID = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "dataSourceID")
  );

  const { username } = useAuth();
  console.log(dataSourcesArray);
  // console.log(dataSourceID);
  // console.log(roles);

  const sheetQuery = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "query")
  );
  // console.log(dataSource);

  // console.log(sheetQuery);
  useEffect(() => {
    let delay;
    if (hoveredIcon) {
      delay = setTimeout(() => {
        setIconToDisplay(hoveredIcon);
      }, 200); // 1-second delay
    } else {
      setIconToDisplay(null);
    }
    return () => clearTimeout(delay);
  }, [hoveredIcon]);
  console.log(VizType);

  const renderIcon = (VizType) => {
    switch (VizType) {
      case "piechart":
        return <MdPieChart className="text-xl text-blue-950" />;
      case "barchart":
        return <MdBarChart className="text-xl text-blue-950" />;
      case "stackedbarchart":
        return <MdStackedBarChart className="text-xl text-blue-950" />;
      case "linechart":
        return <MdLineAxis className="text-xl text-blue-950" />;
      case "treechart":
        return <TbChartTreemap className="text-xl text-blue-950" />;
      case "areachart":
        return <MdAreaChart className="text-xl text-blue-950" />;
      case "simpleTable":
        return <MdPivotTableChart className="text-xl text-blue-950" />;
      case "table":
        return <MdTableChart className="text-xl text-blue-950" />;
      case "scatterchart":
        return <MdScatterPlot className="text-xl text-blue-950" />;
      case "radarchart":
        return <AiOutlineRadarChart className="text-xl text-blue-950" />;
      case "combochart":
        return <TbChartHistogram className="text-xl text-blue-950" />;
      case "bigNumber":
        return <TbNumber123 className="text-xl text-blue-950" />;
      case "cordinatemap":
        return <FaMapMarkerAlt className="text-xl text-blue-950" />;
      default:
        return <LuView className="text-xl text-blue-950" />;
    }
  };

  const {
    data: dataSets,
    isLoading: isDataSetsLoading,
    isError: isDataSetsError,
    error: dataSetsError,
    isSuccess: isDataSetsSuccess,
  } = useGetDatasourceQuery();

  if (isDataSetsSuccess) {
    connnectedDataSets = dataSets.filter((dSet) =>
      dataSourcesArray.some((arrayItem) => dSet.id === arrayItem)
    );
  }

  const hanldeChangeDataSource = (id) => {
    const selectOption = dataSets.find((dSet) => dSet.id === id);
    console.log(selectOption);
    if (selectOption) {
      const hasValues = Object.values(sheetQuery).some(
        (arr) => Array.isArray(arr) && arr.length > 0
      );
      console.log(hasValues);
      if (!hasValues) {
        dispatch(
          updateL1Property({
            SheetId: Sheetid,
            key: "dataSourceID",
            value: id,
          })
        );
      } else {
        setChangeDSModal(true);
      }
      setDataSource({
        NickName: selectOption.NickName,
        id: selectOption.id,
      });
    }
  };

  const selectOption = dataSets
    ? dataSets.find((dSet) => dSet.id === dataSourceID)
    : null;

  const handleSetDataSource = () => {
    const hasValues = Object.values(sheetQuery).some(
      (arr) => Array.isArray(arr) && arr.length > 0
    );

    console.log(hasValues);
    if (dataSource.id) {
      if (!hasValues) {
        // this will change the current sheet's dataSourceID
        dispatch(
          updateL1Property({
            SheetId: Sheetid,
            key: "dataSourceID",
            value: dataSource.id,
          })
        );
        setChangeDSModal(false);
      } else {
        // this will create a new sheet with new dataDourceID
        dispatch(
          CreateSheet({
            isDataSourceChanging: true,
            Action: "CreateSheet",
            newDataSourceID: dataSource.id,
          })
        );
      }
      setChangeDSModal(false);
    }
  };

  const handleResetSheet = () => {
    const sheet = getDefaultReduxState({ vizType: VizType }).newSheetState;

    const actions = {
      onClick: {},
      onDoubleClick: {},
      sort: [],
      quickTable: [],
    };

    const { CustomizeArrayComponents } = getAside2components(VizType);

    let customizationObject = buildCustomization(CustomizeArrayComponents);
    dispatch(
      resetSheet({
        Sheetid,
        query: sheet["query"],
        customization: customizationObject,
        actions,
      })
    );
  };

  const transposeColumns = () => {
    const { rows, groupByFields } = sheetQuery;
    console.log(rows);
    console.log(groupByFields);
    const newQuery = {
      ...sheetQuery,
      rows: groupByFields,
      groupByFields: rows,
    };
    console.log(newQuery);

    dispatch(
      updateL1Property({ SheetId: Sheetid, key: "query", value: newQuery })
    );
  };

  const iconButtons = [
    {
      name: "Go Back",
      icon: (
        <IoArrowBackOutline className="text-xl text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: () => navigate("/datasource"),
      show: true,
      tooltip: "Go Back",
    },
    {
      name: "clearSheet",
      icon: (
        <LuEraser className="text-[20px] font-[500] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: handleResetSheet,
      show: true,
      tooltip: "reset your sheet",
    },
    {
      name: "Undo",
      icon: (
        <GrUndo className="text-xl text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: () => dispatch(ActionCreators.undo()),
      show: true,
      tooltip: "Undo",
    },
    {
      name: "Redo",
      icon: (
        <LuRedo2 className="text-xl text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: () => dispatch(ActionCreators.redo()),
      show: true,
      tooltip: "Redo",
    },
    {
      name: pause ? "Play" : "Pause",
      icon: pause ? (
        <FiPlay className="text-[22px] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ) : (
        <FiPause className="text-[22px] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: handlePlayPause,
      show: VizType !== "cordinatemap",
      tooltip: pause ? "Play" : "Pause",
    },
    {
      name: animationOff ? "Enable Animation" : "Disable Animation",
      icon: animationOff ? (
        <PiShootingStar className="text-[23px] font-[500] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ) : (
        <LuStarOff className="text-[22px] font-[500] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: handleAnimatation,
      show: true,
      tooltip: animationOff ? "Disable Animation" : "Enable Animation",
    },
    {
      name: "Actions",
      icon: (
        <AiOutlineThunderbolt className="text-[22px] font-[500] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: () => setActionModal(!actionModal),
      show: VizType !== "simpleTable",
      tooltip: "Actions",
    },
    {
      name: "Sort",
      icon: (
        <TbArrowsSort className="text-[22px] font-[500] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: () => setSortModal(!sortModal),
      show: ![
        "treechart",
        "radarchart",
        "cordinatemap",
        "areamap",
        "scatterchart",
      ].includes(VizType),
      tooltip: "Sort",
    },
    {
      name: "transpose",
      icon: (
        <TbExchange className="text-[22px] font-[500] text-blue-950 cursor-pointer hover:border hover:border-gray-400 rounded" />
      ),
      onClick: transposeColumns,
      show: true,
      tooltip: "transpose columns",
    },
  ];
  return (
    <>
      <header className="bg-gray-200 h-[38px] px-2 flex items-center justify-between text-black ml-[1px] w-[99.85%] rounded min-h-[38px] z-20">
        <div className="flex items-center justify-between gap-4 relative">
          {iconButtons
            .filter((btn) => btn.show)
            .map((btn, idx) => (
              <div
                key={idx}
                className="relative"
                onMouseEnter={() => setHoveredIcon(btn.name)}
                onMouseLeave={() => setHoveredIcon(null)}
              >
                <div onClick={btn.onClick}>{btn.icon}</div>
                {iconToDisplay === btn.name && (
                  <span
                    className="w-auto z-80 absolute top-7 left-1/2 transform -translate-x-1/2 text-sm bg-black text-white p-1 rounded"
                    style={{
                      minWidth: "5rem",
                      maxWidth: "11rem",
                      width: "auto",
                    }}
                  >
                    {btn.tooltip}
                  </span>
                )}
              </div>
            ))}
        </div>

        {!currentSheetIsDashboard && (
          <div className="flex items-center justify-center gap-5 relative right-[0.5%]">
            {/* add or change dataSources */}
            <div className="relative sm:hidden md:block">
              <Dropdown
                label={
                  <button
                    className="text-black flex items-center rounded justify-between w-48 max-w-60 truncate border border-gray-400 hover:border-blue-950 bg-transparent px-1 py-[2px]"
                    onMouseEnter={() => setHoveredIcon("dataSources")}
                    onMouseLeave={() => setHoveredIcon(null)}
                  >
                    <span className="flex items-center justify-start gap-2">
                      {" "}
                      <TbDatabase className="text-blue-950" />
                      {selectOption !== undefined &&
                        selectOption !== null &&
                        selectOption.NickName}
                    </span>
                    <IoMdArrowDropdown className="text-xl text-black" />
                  </button>
                }
                arrowIcon={false}
                dismissOnClick={true}
                className="shadow-lg"
              >
                <div
                  className={`${
                    Array.isArray(connnectedDataSets) &&
                    connnectedDataSets.length > 3
                      ? "h-40"
                      : "h-auto"
                  }`}
                >
                  {Array.isArray(connnectedDataSets) &&
                  connnectedDataSets.length > 1
                    ? connnectedDataSets.map((item, index) => (
                        <Dropdown.Item
                          key={index}
                          className="flex w-full items-center justify-between px-2 py-1"
                          onClick={() => hanldeChangeDataSource(item.id)}
                        >
                          {item.NickName}
                        </Dropdown.Item>
                      ))
                    : null}

                  <Dropdown.Item
                    className="flex gap-2 w-full items-center justify-start px-2"
                    onClick={() => setDataSourceModal(true)}
                  >
                    <TbDatabasePlus /> new data source
                  </Dropdown.Item>
                </div>
              </Dropdown>
              {iconToDisplay === "dataSources" && (
                <i
                  className="w-auto z-80 absolute top-7 left-1/2 transform -translate-x-1/2 text-sm bg-black text-white p-1 rounded"
                  style={{
                    minWidth: "5rem",
                    maxWidth: "11rem",
                    width: "auto",
                  }}
                >
                  add data sources
                </i>
              )}
            </div>

            {/* download data */}
            <div
              className="relative"
              onMouseEnter={() => setHoveredIcon("download")}
              onMouseLeave={() => setHoveredIcon(null)}
            >
              <button
                className="bg-gray-200 font-bold rounded w-auto z-80 text-[12px] lg:text-[16px] flex gap-2 justify-between items-center py-[2px] px-[1.1rem] text-blue-950 border border-gray-400 hover:border-blue-950"
                onClick={handleCallFunction}
              >
                <MdDownload className="text-blue-950 text-xl" />
              </button>
              {iconToDisplay === "download" && (
                <i
                  className="w-auto z-80 absolute top-7 left-1/2 transform -translate-x-1/2 text-sm bg-black text-white p-1 rounded"
                  style={{
                    minWidth: "5rem",
                    maxWidth: "11rem",
                    width: "auto",
                  }}
                >
                  Download
                </i>
              )}
            </div>
            {/* change viz type */}
            <div
              className="relative"
              onMouseEnter={() => setHoveredIcon("chartType")}
              onMouseLeave={() => setHoveredIcon(null)}
            >
              <button
                className="bg-gray-200 font-bold rounded w-auto z-80 text-[14px] flex gap-2 justify-between items-center py-[2px] px-[8px] text-blue-950 border border-gray-400 hover:border-blue-950 truncate"
                disabled={!currentSheet.Sheetid}
                onClick={handleModal}
              >
                {renderIcon(VizType)}
                Viz Type
              </button>
              {iconToDisplay === "chartType" && (
                <i
                  className="w-auto z-80 absolute top-7 left-1/2 transform -translate-x-1/2 text-sm bg-black text-white p-1 rounded"
                  style={{
                    minWidth: "5rem",
                    maxWidth: "11rem",
                    width: "auto",
                  }}
                >
                  Chart Type
                </i>
              )}
            </div>
            {/* tauu */}
            {roles.includes("Creator") || roles.includes("Admin") ? (
              <div
                className="relative"
                onMouseEnter={() => setHoveredIcon("askTauu")}
                onMouseLeave={() => setHoveredIcon(null)}
              >
                <button
                  className="bg-gray-200 font-bold rounded text-[14px] flex gap-2 justify-center text-center items-center   text-blue-950 w-[2rem] h-[1.72rem] border border-gray-400 hover:border-blue-950"
                  onClick={() => setIsAside4Visible(!isAside4Visible)}
                >
                  <img
                    src="/images/moustache.png" // This path is relative to the public folder
                    alt="Tau"
                    className="w-full"
                  />
                </button>
                {iconToDisplay === "askTauu" && (
                  <i
                    className="w-auto z-80 absolute top-7 left-1/2 transform -translate-x-1/2 text-sm bg-black text-white p-1 rounded"
                    style={{
                      minWidth: "5rem",
                      maxWidth: "11rem",
                      width: "auto",
                    }}
                  >
                    ask Tauu
                  </i>
                )}
              </div>
            ) : null}
          </div>
        )}
      </header>
      {changeDsModal ? (
        <AreYouSureModal
          message={
            "By Changing The Data Source Will Create A New Sheet With New Data Source"
          }
          closeModal={() => setChangeDSModal(false)}
          okayButton={handleSetDataSource}
          modalType={"functional"}
        />
      ) : null}
    </>
  );
}
